import { render, staticRenderFns } from "./ITablePagination.vue?vue&type=template&id=3801d628&"
import script from "./ITablePagination.vue?vue&type=script&lang=js&"
export * from "./ITablePagination.vue?vue&type=script&lang=js&"
import style0 from "./ITablePagination.vue?vue&type=style&index=0&id=3801d628&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports